

































// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { authModule, snackModule } from '@/store';
import { ApiError } from '@/api';
import LoginForm from '@/components/auth/LoginForm.vue';
import RegisterForm from '@/components/auth/RegisterForm.vue';

@Component({
  components: {
    LoginForm,
    RegisterForm,
  },
})
export default class extends Vue {
  get loginTabs() {
    if (!authModule.tab) {
      return 0;
    }
    return authModule.tab;
  }
  set loginTabs(tab: number) {
    authModule.setPopupTab(tab);
  }

  get loginDialog() {
    return authModule.loginDialog;
  }
  set loginDialog(d) {
    if (d) {
      authModule.openLoginDialog({ cb: null });
    } else {
      authModule.closeLoginDialog(false);
    }
  }

  clearLogin() {
    if (this.$refs.loginComponent) {
      (this.$refs.loginComponent as LoginForm).clear();
    }
    if (this.$refs.registerComponent) {
      (this.$refs.registerComponent as RegisterForm).clear();
    }
  }

  @Watch('loginTabs')
  routeChanged() {
    this.clearLogin();
  }
}
